import { gettext } from '@eventbrite/i18n';
import { FilterPanelProps } from '@eventbrite/search-utils';
import React from 'react';
import './FilterPanel.scss';
import Filters from './Filters';

const filters = gettext('Filters');

const DefaultHeader: React.FunctionComponent = () => {
    return <div className="eds-text-hs">{filters}</div>;
};

const FilterPanel: React.FunctionComponent<FilterPanelProps> = (props) => {
    const header = props.header ? props.header : <DefaultHeader />;
    const footer = props.footer;

    return (
        <div className="filter-panel">
            {header}
            <Filters {...props} />
            {footer}
        </div>
    );
};

export default FilterPanel;
